import { type FC } from "react";
import Link from "next/link";
import { Flex } from "@chakra-ui/react";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { Button, TextButton } from "@/components/essentials/button";
import { Divider } from "@/components/essentials/divider";
import { pagesPath } from "@/pathpida/generated/$path";
import { EmailForm } from "@/components/fragments/forms/email-form";
import { PasswordForm } from "@/components/fragments/forms/password-form";
import { type SigninFormValues } from "./type";
import { useFormContext } from "react-hook-form";
import { SignupNavigation } from "@/components/fragments/navigation";
import { buttonSigninTestId } from "./const";

interface SigninFormsProps {
  readonly isRecaptchaLoaded: boolean;
  readonly loading?: boolean;
}
export const SigninForms: FC<SigninFormsProps> = ({ isRecaptchaLoaded, loading }) => {
  const {
    formState: { isValid },
  } = useFormContext<SigninFormValues>();
  return (
    <Flex flexDir="column" gridGap="1.5rem" alignItems="flex-start">
      <Box>
        <Typography variant="display3">登録済みのメールアドレスでサインイン</Typography>
      </Box>
      <EmailForm />
      <PasswordForm />
      <TextButton as={Link} href={pagesPath.signin.reset.$url()} color="mono.dark.54" size="sm" alignSelf="flex-end">
        パスワードをお忘れの方はこちら
      </TextButton>
      <Box w="100%" my="2rem" textAlign="center">
        <Button
          data-testid={buttonSigninTestId}
          isLoading={loading}
          type="submit"
          size="lg"
          w="100%"
          styleVariant="secondary"
          disabled={!isValid || !isRecaptchaLoaded || loading}
        >
          サインインする
        </Button>
      </Box>
      <Divider variant="light" />
      <SignupNavigation />
    </Flex>
  );
};
